// React
import React from "react";

// Material UI
import { useTheme } from "@mui/material/styles";
import {
  Button,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import PreviewOutlinedIcon from "@mui/icons-material/PreviewOutlined";
import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";

function FilterTable({ name, data, filters }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const theme = useTheme();

  // const open = anchorEl === null ? false : true;
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div
      style={{
        backgroundColor: "#F7F9FB",
        borderRadius: "8px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "3px",
        paddingLeft: "8px",
        paddingRight: "8px",
        marginTop: "11px",
        height: "40px",
        maxWidth: "1200px",
      }}
    >
      <div style={{ display: "flex" }}>
        {filters?.dropDown ? (
          <>
            <div>
              <IconButton
                id="demo-positioned-button"
                aria-controls={open ? "demo-positioned-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
              >
                <AddIcon color="action" fontSize="small" />
              </IconButton>
              <Menu
                id="demo-positioned-menu"
                aria-labelledby="demo-positioned-button"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                {filters?.dropDownData?.map((data, index) => {
                  return (
                    <MenuItem key={index} onClick={() => data.fun()}>
                      {data.label}
                    </MenuItem>
                  );
                })}
              </Menu>
            </div>
          </>
        ) : (
          <>
            {filters.add && (
              <IconButton onClick={() => filters.add()}>
                <AddIcon color="action" fontSize="small" />
              </IconButton>
            )}
            {filters.addFromSite && (
              <Button
                onClick={() => {
                  filters.addFromSite();
                }}
                size="small"
                style={{
                  textTransform: "capitalize",
                  color: "white",
                  backgroundColor: "black",
                  "&:hover": { background: `${theme.color.black}` },
                }}
              >
                <GroupAddOutlinedIcon fontSize="small" />
                Add all employees
              </Button>
            )}
            {filters.preview && (
              <Button
                sx={{
                  textTransform: "capitalize",
                  color: "grey",
                }}
                onClick={() => filters.preview()}
              >
                <PreviewOutlinedIcon color="action" fontSize="small" />
                <span>Preview</span>
              </Button>
            )}
          </>
        )}
        {name ? (
          <Typography variant="Poster" component="h5" mb={1}>
            {name}
          </Typography>
        ) : (
          <> </>
        )}
      </div>

      <div
        style={{
          width: "fit-content",
          display: "flex",
          alignItems: "center",
          fontSize: "13px",
          marginRight: "60px",
          gap: 5,
          color: "rgba(0, 0, 0, 0.5)",
        }}
      >
        {filters.SendAllInvoices && (
          <Button
            onClick={() => {
              filters.SendAllInvoices();
            }}
            size="small"
            style={{
              textTransform: "capitalize",
              color: "white",
              marginInline:"20px",
              backgroundColor: "black",
              "&:hover": { background: `${theme.color.black}` },
            }}
          >
            Send All
          </Button>
        )}
        {filters.pagination && (
          <>
            {" "}
            <span>Rows per page:</span>
            <TextField
              id="demo-simple-select"
              value={filters.page}
              select={true}
              size="small"
              onChange={(e) => filters.changePageSize(e.target.value)}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </TextField>
          </>
        )}
        {filters?.deleteAllSites && (
          <Button
            variant="contained"
            style={{ background: "#FF4747" }}
            onClick={filters?.deleteAllSites}
          >
            Delete All Sites
          </Button>
        )}
      </div>
      {filters?.text && (
        <Typography sx={{ fontSize: "13px", fontWeight: "bold" }}>
          {filters?.text}
        </Typography>
      )}
    </div>
  );
}

export default FilterTable;
